<template>
    <div class="common_left_submenuClass">
        <el-submenu
            v-if="menu.children && menu.children.length >= 1"
            :index="menu.uuid" class="menuChildCLass">
            <template slot="title">
                {{ menu.name }}
            </template>
            <sub-menu
                v-for="item in menu.children"
                :key="item.uuid"
                :menu="item">
            </sub-menu>
        </el-submenu>
        <el-menu-item v-else :index="menu.uuid" @click="navMenuClick(menu)">
                        <span slot="title">
                            <i :class="menu.icon"></i><span>{{ menu.name }}</span>
                        </span>
        </el-menu-item>
    </div>
</template>

<script>
    import SubMenu from './common_left_submenu'
    
    export default {
        name: 'sub-menu',
        data() {
            return {
                menuId: ''
            }
        },
        props: {
            menu: {
                type: Object,
                required: true
            }
        },
        components: {
            SubMenu
        },
        computed: {},
        mounted(){
        },
        methods: {
            navMenuClick(val) {
                if (val.url) {
                    this.$router.push(val.url);
                    this.$store.commit('updateMenuActiveId', val.uuid);
                    this.$store.commit('upDateMenuActiveName', val.name)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/layout/common_left_submenu.vue